<app-header/>

<div class="user-info">
  <div class="row">
    <a routerLink="/account" class="alert">Продовжити покупки</a>
  </div>
  <h2 class="user-name">{{userInfo.fio}}</h2>
  <div class="user-id">
    ID:
    <span>{{userInfo.user_id}}</span>
  </div>

  <hr>

  <div class="row" [class.menu-is-selected]="pageType === 1">
    <span class="menu-style" routerLink="/orders_history_new">Замовлення по передплатам</span>
  </div>

  <div class="row" [class.menu-is-selected]="pageType === 2" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
    <span class="menu-style" routerLink="/orders_history_nalojki">Замовлення по накладеним платежах</span>
  </div>

  <div class="row" [class.menu-is-selected]="pageType === 3" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
    <span class="menu-style" routerLink="/orders">Заявки на повернення</span>
  </div>

  <div class="row" [class.menu-is-selected]="pageType === 4">
    <span class="menu-style" routerLink="/favorites">Список побажань</span>
  </div>

  <div class="row" [class.menu-is-selected]="pageType === 5">
    <span class="menu-style" routerLink="/personal">Налаштування акаунту</span>
  </div>
</div>

<div class="flex-container">
  <div class="mobile-menu-btn">
    <img (click)="userMobileMenuShow()" src="/assets/images/icons/menuicon.svg">
  </div>
  <div class="title-styles" *ngIf="pageType === 1">Замовлення по передплатам</div>
  <div class="title-styles" *ngIf="pageType === 2 && (!activeOrganization || activeOrganization.type === 'fiz')">Замовлення по накладеним платежах</div>
  <div class="title-styles" *ngIf="pageType === 3 && (!activeOrganization || activeOrganization.type === 'fiz')">Заявки на повернення</div>
  <div class="title-styles" *ngIf="pageType === 4">Список побажань</div>
  <div class="title-styles" *ngIf="pageType === 5">Налаштування акаунту</div>
</div>

<div class="mobile-menu" *ngIf="mobileMenuShow">
  <div class="cross">
    <a class="close-mobile-menu" (click)="closeMobileMenu()"></a>
  </div>
  <ul>
    <li [class.mobile-menu-is-selected]="pageType === 1">
      <a routerLink="/orders_history_new">Замовлення по передплатам</a>
    </li>
    <li [class.mobile-menu-is-selected]="pageType === 2" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
      <a routerLink="/orders_history_nalojki">Замовлення по накладеним <br> платежах</a>
    </li>
    <li [class.mobile-menu-is-selected]="pageType === 3" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
      <a routerLink="/orders">Заявки на повернення</a>
    </li>
    <li [class.mobile-menu-is-selected]="pageType === 4">
      <a routerLink="/favorites">Список побажань</a>
    </li>
    <li [class.mobile-menu-is-selected]="pageType === 5">
      <a routerLink="/personal">Налаштування акаунту</a>
    </li>
  </ul>
</div>

<div class="dark-layer" *ngIf="mobileMenuShow" (click)="closeMobileMenu()"></div>
